import PhotoTour from "./photoTour";
import MainCarousel from "./mainCarousel";
import LastChance from "@/app/(custom-header)/prizes/house-v2/components/LastChance";
import React, { useContext } from "react";
import UKsNo1 from "@/app/(custom-header)/prizes/house-v2/components/UKsNo1";
import WinnersSlider from "@/app/(custom-header)/prizes/house-v2/components/WinnersSlider";
import AsSeenOnLogos from "@/app/(custom-header)/prizes/house-v2/components/AsSeenOnLogos";
import AccordionDetails from "@/app/(custom-header)/prizes/house-v2/components/AccordionDetails";
import HomeSpecs from "@/app/(custom-header)/prizes/house-v2/components/HomeSpecs";
import CountdownTimer from "../../../components/Countdown/countdown";
import Button from "../../../components/Button/button";
import { useCompetition } from "../../../redux/features/categories/selectors";
import { HouseCompetitionData } from "./contextProvider";
import EnterNowButton from "./EnterNowButton";

const HouseCompetitionForMobile = () => {
  const houseCompetition = useCompetition({
    CompetitionTypePrefix: "HC",
  });
  const houseCompetitionData = useContext(HouseCompetitionData);
  const { isPrizeAvailable } = houseCompetitionData;
  return (
    <section className="flex flex-col justify-center gap-8">
      <MainCarousel />
      <div className="mx-4 flex flex-col gap-8">
        <LastChance />
        <UKsNo1 />
        <WinnersSlider />
        <AsSeenOnLogos />

        {isPrizeAvailable ? (
          <div className={`house-prize-btn-wrapper font-jost max-lg:fixed bottom-0 left-0 right-0 w-full lg:p-0`}>
            <div className={"bg-black/90 py-2"}>
              <div className={"text-gray-4 text-center text-base leading-6 font-normal"}>
                {houseCompetition.FeaturedPrizeModel}
              </div>
              <CountdownTimer
                EndDateTime={new Date(houseCompetition.EndDateTime)}
                textClass={"uppercase text-gray-4 text-base leading-6 font-normal mr-1"}
                numericClass={"text-gray-4 font-bold text-base leading-6"}
                containerClass={"flex justify-center items-center gap-[2px] leading-none"}
                format="d:h:m:s"
              />
            </div>
            <EnterNowButton text={"ENTER NOW"} variation={"mobile_sticky"} place={"house_new_floating_cta"} />
          </div>
        ) : (
          <Button
            className="w-full uppercase flex justify-center items-center text-[#696971] font-medium text-[17px] bg-white h-[60px] gap-[11px] rounded-0 p-4 relative border border-solid border-[#696971]"
            onClick={e => {
              e.stopPropagation();
            }}
            text="Not Currently Available"
          />
        )}
      </div>
      <HomeSpecs />

      <div className="mx-4 flex flex-col gap-8 mb-8">
        <PhotoTour />
        <AccordionDetails />
      </div>
    </section>
  );
};

export default HouseCompetitionForMobile;
